module.exports = __webpack_public_path__ + "static/media/barcode.1ee3dcea.svg";